import { OnInit, ElementRef, HostListener } from '@angular/core';
import { Component } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService } from '@/services/auth.service';
import { Router } from '@angular/router';
import { ApiService } from '@/services/api.service';
import { ActivatedRoute } from '@angular/router';
import { User } from '@/helper/auth.helper';

@Component({
    selector: 'app-user-menu-dropdown',
    standalone: true,
    imports: [CommonModule, Dialog, ButtonModule, TooltipModule, TranslatePipe],
    templateUrl: './user-menu-dropdown.html',
    styleUrl: './user-menu-dropdown.scss',
})
export class UserMenuDropdown implements OnInit {
    visible: boolean = false;
    apiUrl: string = (window as any)['__env'].apiEndpoint;
    user: Partial<User> = new User();
    roles: string[] = [];

    position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'topright';

    showSpinner = false;

    constructor(
        public authService: AuthService,
        public apiService: ApiService,
        public router: Router,
        private elementRef: ElementRef,
        private route: ActivatedRoute,
    ) {}

    ngOnInit() {
        this.authService.sessionData.subscribe(data => {
            this.user = data.user;
        });
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        if (!this.visible) return;

        const clickedElement = event.target as HTMLElement;
        const dialogElement = document.querySelector('.p-dialog');
        const triggerButton = this.elementRef.nativeElement.querySelector('.layout-topbar-action');

        // Check if click is outside both the dialog and the trigger button
        if (
            dialogElement &&
            !dialogElement.contains(clickedElement) &&
            !triggerButton?.contains(clickedElement)
        ) {
            this.visible = false;
        }
    }

    showDialog(position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright') {
        if (!this.visible) {
            this.position = position;
            this.visible = true;
        } else {
            this.visible = false;
        }
    }

    goToProfile() {
        if (this.user) {
            this.visible = false;
            if (this.user.isSystemAdmin || (this.user.roles && this.user.roles.length && this.user.roles.includes("administration"))) {
                this.router.navigate(['/admin/profile']);
            }
        }
    }

    goToProfileEdit() {
        if (this.user) {
            if (this.user.roles && this.user.roles.length && (this.user.isSystemAdmin || this.user.roles.includes("administration"))) {
                this.visible = false;
                this.router.navigate(['/admin/profile/edit']);
            }
        }
    }

    goToAdminPage() {
        if (this.user) {
            if (this.user.isSystemAdmin || (this.user.roles && this.user.roles.length && this.user.roles.includes("administration"))) {
                this.visible = false;
                this.router.navigate(['/admin']);
            }
        }
    }

    goToDeliveryAddresses() {
        this.visible = false;
        this.router.navigate(['/store/profile/myaddresses']);
        this.visible = false;
    }

    logout() {
        if (this.user.oidcIdentifier?.length) {
            this.oidcLogout();
        } else {
            this.authService.logout().subscribe((success) => {
                if (success) {
                    this.router.navigate(['/login']);
                }
            })
        }
    }

    oidcLogout() {
        this.showSpinner = true;
        this.route.queryParams.subscribe(params => {
            const host: string = (window as any)['__env'].apiEndpoint;
            if (params['returnUrl']) {
                window.location.href = `${host}/v1/auth/oidc/logout?returnUrl=${params['returnUrl']}`;
            } else {
                window.location.href = `${host}/v1/auth/oidc/logout`;
            }
        });
    }
}
